import {createModel} from "@rematch/core";
import {RootModel} from "./index";
import request from "../util/request";

export const serviceOrders: any = createModel<RootModel>()({
  state: {
    info: {},
    request: {
      keywords: "",
      pageNum: 1,
      pageSize: 20,
      serviceId: "",
      payStatus: "",
    },
    data: {
      total: 0,
      pageNum: 1,
      pageSize: 20,
      list: [],
    },
    services: [],
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    /**
     * 设置值
     *
     * @param state
     * @param payload
     */
    setData(state, payload) {
      return {...state, ...payload}
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    /**
     * 分页获取订单列表
     */
    async getPage(payload, rootState) {
      let res = await request.post("/host-admin/v1/serviceOrders/page", rootState.serviceOrders.request)
      if (res.code === 0) {
        res.data.list.forEach((item: any) => {
          item.key = item.orderNo
        })
        dispatch.serviceOrders.setData({data: res.data})
      }
      return res
    },

    /**
     * 获取订单详情
     *
     * @param orderNo
     * @param rootState
     */
    async getInfo(orderNo, rootState) {
      let res = await request.get(`/host-admin/v1/serviceOrders/info/${orderNo}`)
      if (res.code === 0) {
        dispatch.serviceOrders.setData({info: res.data})
      }
      return res
    },

    /**
     * 订单退款
     *
     * @param orderNo
     * @param rootState
     */
    async refund(orderNo, rootState) {
      let res = await request.post(`/host-admin/v1/serviceOrders/refund/${orderNo}`, {})
      return res
    },

    /**
     * 获取服务列表
     */
    async getServices(payload, rootState) {
      let res = await request.get("/host-admin/v1/serviceOrders/services")
      if (res.code === 0) {
        dispatch.serviceOrders.setData({services: res.data})
      }
      return res
    },

    /**
     * 下载服务订单
     *
     * @param payload
     * @param rootState
     */
    async download(payload, rootState) {
      let params = {
        serviceId: rootState.serviceOrders.request.serviceId,
        payStatus: rootState.serviceOrders.request.payStatus
      }
      await request.download("/host-admin/v1/serviceOrders/download", params, "serviceOrders.xlsx")
    },

  }),
}) 